import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

export const SettingsPanel = ({ customer, onSave, showReminders = true }) => {
  const [f, setF] = useState({ name: customer.name, phone: customer.phone });
  const [reminders, setReminders] = useState(true);
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    if (f.name.trim().length < 2) return toast.error("Please enter your name.");
    setBusy(true);
    try {
      await onSave(f);
      toast.success("Account details saved.");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={save} className="space-y-5" data-testid="settings-form">
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-1.5">
          <Label htmlFor="set-name">Full name</Label>
          <Input id="set-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="lc-input" data-testid="settings-name-input" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="set-phone">Telephone</Label>
          <Input id="set-phone" type="tel" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className="lc-input" data-testid="settings-phone-input" />
        </div>
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="set-email">Email (used to sign in)</Label>
        <Input id="set-email" value={customer.email} disabled className="lc-input opacity-70" data-testid="settings-email-input" />
      </div>
      {showReminders && <div className="flex items-center justify-between rounded-2xl border border-[#262626] p-4">
        <div>
          <p className="font-medium">Delivery reminder emails</p>
          <p className="text-sm text-[#A1A1AA]">A heads-up before each delivery.</p>
        </div>
        <Switch checked={reminders} onCheckedChange={setReminders} aria-label="Delivery reminder emails" data-testid="settings-reminders-switch" />
      </div>}
      <button type="submit" disabled={busy} className="lc-btn-primary" data-testid="settings-save">Save details</button>
    </form>
  );
};
